import { Icon } from '@mui/material';
import DynamicIcon from '../dynamicicon';

function FlowItem({flow,pos,code, title  }) {
 
  const flow_class=(p,c)=>{
    return `item ${flow.pos>p?'checked':flow.code==c?'active':'inactive'} `;
}

  return <div className={ flow_class(pos,code)}>
                       {flow.pos>pos?<span  className='circle'><DynamicIcon size={25} iname="circle-check"/></span>:<span className='circle'><DynamicIcon iname="circle" size={25} /></span> }   
                        <span className='label'>{title}</span> 
                    </div>;
}

export default FlowItem;